import { render, staticRenderFns } from "./SponsorsListPreview.vue?vue&type=template&id=f10d5834&scoped=true&"
import script from "./SponsorsListPreview.vue?vue&type=script&lang=js&"
export * from "./SponsorsListPreview.vue?vue&type=script&lang=js&"
import style0 from "./SponsorsListPreview.vue?vue&type=style&index=0&id=f10d5834&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f10d5834",
  null
  
)

export default component.exports